
import { Button, Table } from 'antd'
import React from 'react'
import { mapAccountingRecordDataRange } from '../../../axios/dictionaries'
import { CustomCol, CustomRow } from '../../../components/Custom'
import DetailTitle from '../../../components/DetailTitle'
import { apiAccountingRecordReceiptConfirmationExport, fetchAccountingRecordReceiptConfirmationDetails } from '../../../services/accountingRecord'
import { findDict, handleExportParams, ToParamForObject } from '../../../utils'

/** 
 * 
 * @Author: zhao - 🍉
 * @Date: 2021-12-20 17:27:27
 * @LastEditTime: 2021-12-21 09:58:22
 * @LastEditors: zhao - 🍉
 * @Description:  到账确认书详情数据
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/components/ReceiptConfirmationView.jsx
 */
class ReceiptConfirmationView extends React.Component{
    constructor() {
        super()
        this.state = {
            dbillConfirmLogDataata: {}
        }
    }
    componentDidMount() {
        this.postAccountingRecordReceiptConfirmationDetails()
    }

    postAccountingRecordReceiptConfirmationDetails() {
        const data = { accountingRecordLogId: this.props.accountingRecordLogId }
        fetchAccountingRecordReceiptConfirmationDetails(data).then(res => {
            this.setState({ receiptConfirmationData: res })
        })
    }
    render(){
        const { labelWidth } = this.props
        const { receiptConfirmationData = {} } = this.state
        const infoLogColumns  = [
            // { title: '收款单位', dataIndex: 'accountName' },
            // { title: '收款账号', dataIndex: 'accountNumber' },
            // { title: '开户行', dataIndex: 'bankName' },
            // { title: '开户行行号', dataIndex: 'bankNo' },
            { title: '楼栋名称', dataIndex: 'buildingName' },
            { title: '业主', dataIndex: 'owner' },
            { title: '租金', dataIndex: 'rent' },
        ]
        const exportParmas = ToParamForObject({ 
            accountingRecordLogId: this.props.accountingRecordLogId,
            ...handleExportParams()
        })
        const exportUrl = apiAccountingRecordReceiptConfirmationExport + '?' + exportParmas
        return (
            <div>
                <Button  type="primary" icon="export" href={exportUrl} style={{position: 'absolute', right: 0, top: 50}}>
                    导出
                </Button>
                <DetailTitle title="基础信息" />
                <CustomRow >
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="商户名称">
                        {receiptConfirmationData.merchantName}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="所属月份">
                        {receiptConfirmationData.month}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="汇集期数">
                        {receiptConfirmationData.collectionPeriod}
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="开始日期">
                        {receiptConfirmationData.startDate}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="结束日期">
                        {receiptConfirmationData.endDate}
                    </CustomCol>
                    {/*<CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="付款日期">*/}
                    {/*    {receiptConfirmationData.paymentDate}*/}
                    {/*</CustomCol>*/}
                </CustomRow>
                <CustomRow divider>

                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="付款总额">
                        {receiptConfirmationData.paymentTotal}
                    </CustomCol>
                </CustomRow>
              
                <DetailTitle title="明细数据" />
                <Table 
                    columns={infoLogColumns}
                    dataSource={receiptConfirmationData.infoLogList}
                    scroll={{x: 900}}
                />
            </div>
        )
    }
}

export default ReceiptConfirmationView


// WEBPACK FOOTER //
// ./src/page/AccountingRecord/components/ReceiptConfirmationView.jsx